import React from 'react'
import axios from 'axios';
import NumberFormat from 'react-number-format';



class TimeSelect extends React.Component {

	constructor(props) {
		super(props);

		const defaultTimes = ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'].map((time, index) => {
			return { time: time, price: false, id: false }
		})

		this.state = {
			times: defaultTimes,
			loading: false
		}

	}

	componentDidMount = () => {
		if( this.props.date != undefined && this.props.date != null ) {
			this.getTimes()
		}
	}

	getTimes = () => {		
		this.setState({ loading: true, times: [] }, function() {
			const url = '/products/' + this.props.id + '/times';
			axios.post( url, {
					authenticity_token: this.props.token,
					id: this.props.id,
					date: this.props.date.format('DD/MM/YYYY'),
					pax: this.props.pax
			}).then( response => {
				this.setState({
					times: response.data,
					loading: false
				}, function() {
					this.preSelectTime()
				});
			}).catch(err => {
				console.log(err);
			});
		});
	}

	preSelectTime = () => {
		if( this.state.times.length > 0 ) {
			//found some times
			if( this.state.times.length == 1 ) {
				this.props.handleTimeChange( this.state.times[0], 0 );
			} else {
				if( this.props.time ) {
					//find if this.props.time is in this.statetimes
					const timeIndex = this.state.times.findIndex( time => time.time == this.props.time )
					if( timeIndex != -1 ) {
						this.props.handleTimeChange( this.state.times[timeIndex], timeIndex );
					} else {
						//already selected a time that this date doesn't offer - don't leave it set
						this.props.handleTimeChange( false, 0 );
					}
				}
			}
		} else {
			//no times found - reset the form
			this.props.handleTimeChange( false, 0 );
		}
	}

	selectTime = ( event ) => {
		event.preventDefault();
		const timeIndex = event.target.value
		if( timeIndex != '' ) {
			const time = this.state.times[event.target.value]
			this.props.handleTimeChange( time, event.target.value );
		}
	}

	render() {
		return (
			<select value={this.props.value} onChange={this.selectTime} disabled={!this.props.active}>
				<option value="">{this.props.active ? 'Time' : 'Select a date first'}</option>
				{this.state.times.map((time, index) => {
					return (
						<option value={index} key={`time-`+time.time}>{time.time}</option>
					)
				})}
			</select>
		)
	}
}

export default TimeSelect
